import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { TSaldivar } from './TSaldivar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <TSaldivar />
  </React.StrictMode>
);
